const MSLA = 'MSLA';
const BR500 = 'BR500';
const DPC = 'DPC';
const INVD = 'INVD';
const SMD = 'SMD'

export {MSLA, BR500, DPC, INVD, SMD};